/**
 * Canonical SLIK customer-facing URLs — ONE source of truth so booking/portal links can never
 * drift again. (Jose 2026-09-06, after a dead link + two drifted URLs surfaced.)
 *
 * The three customer surfaces (all separate apps / Firebase sites, one project):
 *   - book.slikbarberlounge.com  → PUBLIC BOOKING (public-booking) — the landing + sign-in; where
 *     customers START. Signing in here redirects them to the portal (my.).
 *   - my.slikbarberlounge.com    → CUSTOMER PORTAL (customer-portal) — authenticated account/portal.
 *   - app.slikbarberlounge.com   → STAFF POS (this app) — internal.
 *
 * DEAD (never use): slik-customer-portal.web.app (404). Prefer the branded domains over raw *.web.app.
 */

/** Public landing / booking entry point — where customers begin (and sign in). */
export const BOOKING_URL = 'https://book.slikbarberlounge.com';

/** Authenticated customer portal — account, dashboard, claim/accept flows. */
export const PORTAL_URL = 'https://my.slikbarberlounge.com';
